/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ValueListItemFromJSON(json) {
    return ValueListItemFromJSONTyped(json, false);
}
export function ValueListItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'valueListId': !exists(json, 'valueListId') ? undefined : json['valueListId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'valueListName': !exists(json, 'valueListName') ? undefined : json['valueListName'],
        'valueListValue': !exists(json, 'valueListValue') ? undefined : json['valueListValue'],
        'displaySequence': !exists(json, 'displaySequence') ? undefined : json['displaySequence'],
        'reqPriority': !exists(json, 'reqPriority') ? undefined : json['reqPriority'],
        'requestToJobType': !exists(json, 'requestToJobType') ? undefined : json['requestToJobType'],
    };
}
export function ValueListItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'valueListId': value.valueListId,
        'propertyId': value.propertyId,
        'valueListName': value.valueListName,
        'valueListValue': value.valueListValue,
        'displaySequence': value.displaySequence,
        'reqPriority': value.reqPriority,
        'requestToJobType': value.requestToJobType,
    };
}
